import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Main component
import { AppComponent } from '@app/app.component';

// Routing
import { AppRoutingModule } from '@app/app-routing.module';

// Core
import { CoreModule } from '@core/core.module';

// TECH components
import { TechScrollbarModule } from '@tech/components/tech-scrollbar';

// Default Components
import { LoadingLogoComponent } from '@app/components/loading-logo/loading-logo.component';
import { NotificationServiceComponent } from '@app/components/notification-service/notification-service.component';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NetInterceptor } from './features/logger/net-interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { NavbarComponent } from './features/receipts/components/navbar/navbar.component';

@NgModule({
  declarations: [AppComponent],
  imports: [
    NavbarComponent,
    CommonModule,
    CoreModule,
    AppRoutingModule,
    TechScrollbarModule,
    LoadingLogoComponent,
    NotificationServiceComponent,
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NetInterceptor,
      multi: true,
    },
    provideAnimationsAsync(),
  ],
})
export class AppModule {}
